import React from 'react';
import './SuccessToast.css';
import { CheckCircle, AlertTriangle, Info, XCircle, X } from 'lucide-react';

const SuccessToast = ({ toast, onClose }) => {
    if (!toast) return null;

    const type = toast.type || 'success';
    const isPersistent = Boolean(toast.persistent);
    
    const getIcon = () => {
        switch (type) {
            case 'success': return <CheckCircle size={18} />;
            case 'error': return <XCircle size={18} />;
            case 'warning': return <AlertTriangle size={18} />;
            case 'info': return <Info size={18} />;
            default: return <CheckCircle size={18} />;
        }
    };

    let title = toast.message || '';
    let subtitle = toast.rfpName || '';
    
    // Strip leading symbols
    title = title.replace(/^[✓✗!]\s*/, '');
    
    // Parse parentheses details into subtitle if subtitle is empty
    if (!subtitle && title.includes('(') && title.includes(')')) {
        const match = title.match(/^(.*?)\s*\((.*?)\)$/);
        if (match) {
            title = match[1];
            subtitle = match[2];
        }
    }

    const handleDismiss = () => {
        if (toast.onClose) toast.onClose();
        if (onClose) onClose();
    };

    return (
        <div className={`success-toast-notification toast-${type} ${isPersistent ? 'toast-persistent' : ''}`}>
            <div className={`toast-icon-wrapper icon-${type}`}>
                {getIcon()}
            </div>
            <div className="toast-content" style={{ flex: 1 }}>
                <div className="toast-title">{title}</div>
                {subtitle && <div className="toast-subtitle">{subtitle}</div>}
            </div>
            {(onClose || isPersistent) && (
                <button
                    onClick={handleDismiss}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: type === 'warning' ? '#B45309' : '#64748B',
                        cursor: 'pointer',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '4px',
                        marginLeft: '8px',
                        transition: 'opacity 0.2s'
                    }}
                    title="Dismiss notification"
                >
                    <X size={16} />
                </button>
            )}
        </div>
    );
};

export default SuccessToast;
